export const useDevice = () => {
  const iOS = /iPad|iPhone|Macintosh|iPod/.test(navigator.userAgent);
  const Android = /Android/.test(navigator.userAgent);
  return { isIos: iOS, isAndroid: Android };
};
